module.exports = __webpack_public_path__ + "static/media/03_Testimonial.18469487.jpg";